import React from 'react';
import { Link, Redirect, withRouter } from 'react-router-dom';
import logo from '../../assets/images/logos/powertrack.png';

const Login = ({ history }) => {
  return (
    <div
      className="d-flex flex-column text-center align-items-center justify-content-center"
      style={{ height: '100vh' }}
    >
      <div
        className="container"
        style={{ position: 'relative', height: '60%', width: '350px' }}
      >
        <div className="mb-4 pb-2 mx-auto" style={{ width: '200px' }}>
          <img src={logo} style={{ width: '200px' }} alt="" />
        </div>
        <h5 className="pt-4">Manpower Login</h5>

        <button
          onClick={() => history.push('/login/admin')}
          className="btn btn-brand my-3 btn-block"
          style={{ textDecoration: 'none' }}
        >
          Admin
        </button>
        <button
          onClick={() => history.push('/login/client')}
          className="btn btn-brand my-3 btn-block"
          style={{ textDecoration: 'none' }}
        >
          Client
        </button>
        <button
          onClick={() => history.push('/login/supervisor')}
          className="btn btn-brand my-3 btn-block"
          style={{ textDecoration: 'none' }}
        >
          Supervisor
        </button>
      </div>
    </div>
  );
};

export default withRouter(Login);
